import React from 'react';
import { Spinner } from 'react-bootstrap';

import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';
import ModalCadastrar from 'components/Windx/ControlPanel/SimulacoesAntigasSalvas/ModalCadastrar';
import SimulacaoItem from 'components/Windx/ControlPanel/SimulacoesAntigasSalvas/SimulacaoItem';
import useSimulacoesAntigasSalvas, {
  LIMITE_POR_USUARIO,
} from 'components/Windx/ControlPanel/SimulacoesAntigasSalvas/useSimulacoesAntigasSalvas';
import { PainelOptions } from 'helper/windx';
import { LIMITE_SIMULACOES_ANTIGAS_ATIVAS } from 'redux/reducers/windxControlPanelReducer';

interface SimulacoesAntigasProps {
  opts: PainelOptions;
  dataMinima: string;
  dataMaxima: string;
}

/**
 * Corpo da secao "Simulações Antigas" do painel mobile (apenas WEOL-SH).
 *
 * REUSA do desktop: o estado e as acoes (`useSimulacoesAntigasSalvas`), a linha
 * (`SimulacaoItem`) e o formulario (`ModalCadastrar`). Nenhum dos tres e
 * `Accordion.Item`, entao cabem dentro do `Section` do BottomSheet.
 *
 * Reescrever o formulario aqui significaria duplicar as validacoes e a
 * conversao data -> `dias_atras` (FE-WINDX-043) — exatamente o tipo de
 * divergencia que a iniciativa evita.
 */
export default function SimulacoesAntigas({
  opts, dataMinima, dataMaxima,
}: SimulacoesAntigasProps) {
  const {
    items, isLoading, isDeleting, idsAtivos,
    atingiuLimiteAtivas, atingiuLimiteSalvas, modal,
    abrirCadastro, handleToggle, handleEditar, handleDeletar, handleCloseModal,
  } = useSimulacoesAntigasSalvas();

  if (isLoading) {
    return (
      <div className="text-center py-2">
        <Spinner
          animation="border"
          size="sm"
          role="status"
          aria-label="Carregando simulações antigas"
        />
      </div>
    );
  }

  return (
    <>
      <p className="windx-sheet-dica">
        {`Máximo ${LIMITE_SIMULACOES_ANTIGAS_ATIVAS} simulações ativas simultaneamente.`}
      </p>

      {items.length === 0 && (
        <p className="windx-sheet-placeholder">
          Nenhuma simulação antiga salva.
        </p>
      )}

      {items.map((sim) => (
        <SimulacaoItem
          key={sim.id}
          sim={sim}
          ativa={idsAtivos.includes(sim.id)}
          bloqueado={atingiuLimiteAtivas}
          isDeleting={isDeleting}
          onToggle={handleToggle}
          onEditar={handleEditar}
          onDeletar={handleDeletar}
        />
      ))}

      {atingiuLimiteSalvas && (
        <p className="windx-sheet-dica">
          {`Limite de ${LIMITE_POR_USUARIO} simulações salvas atingido. Exclua uma para criar nova.`}
        </p>
      )}

      <SheetActionButton
        variant="secondary"
        onClick={abrirCadastro}
        disabled={atingiuLimiteSalvas}
      >
        Cadastrar simulação
      </SheetActionButton>

      <ModalCadastrar
        open={modal.tipo !== 'fechado'}
        initialValue={modal.tipo === 'editar' ? modal.sim : undefined}
        opts={opts}
        dataMinima={dataMinima}
        dataMaxima={dataMaxima}
        onClose={handleCloseModal}
      />
    </>
  );
}
